import LocationFragment from 'garaje/graphql/fragments/roomba/LocationFragment';
import gql from 'graphql-tag';

export default gql`
  mutation UpdateRoomsLocationShouldEmailLocationAdmins($locationId: ID!, $shouldEmailLocationAdmins: Boolean!) {
    updateRoomsLocationShouldEmailLocationAdmins(
      locationId: $locationId
      shouldEmailLocationAdmins: $shouldEmailLocationAdmins
    ) {
      ...LocationFragment
    }
  }
  ${LocationFragment}
`;
